/**
 * @generated SignedSource<<245dd24cc587bd7c87a525963cb96402>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddScreenAssignDashboardMutation$variables = {
  dashboardId: string;
  screenId: string;
};
export type AddScreenAssignDashboardMutation$data = {
  readonly storecast: {
    readonly setScreenDashboard: {
      readonly dashboard: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly name: string;
    };
  };
};
export type AddScreenAssignDashboardMutation = {
  response: AddScreenAssignDashboardMutation$data;
  variables: AddScreenAssignDashboardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dashboardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "dashboardId",
            "variableName": "dashboardId"
          },
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "setScreenDashboard",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "dashboard",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddScreenAssignDashboardMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddScreenAssignDashboardMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "d8806b085ff27215e5b64cad0c9523a1",
    "id": null,
    "metadata": {},
    "name": "AddScreenAssignDashboardMutation",
    "operationKind": "mutation",
    "text": "mutation AddScreenAssignDashboardMutation(\n  $screenId: ID!\n  $dashboardId: ID!\n) {\n  storecast {\n    setScreenDashboard(screenId: $screenId, dashboardId: $dashboardId) {\n      id\n      name\n      dashboard {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "60139af6606bd34058ed1a20905ff43f";

export default node;
